import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/services/core/shared.service';

@Component({
    templateUrl: './service-center-complaints.component.html',
    standalone: false
})
export class ServiceCenterComplaintsComponent implements OnInit {

  constructor(public sharedService: SharedService) { }

  ngOnInit(): void {
  }

}
